import { render, staticRenderFns } from "./ExtraAttributesForm.vue?vue&type=template&id=1536ad62"
import script from "./ExtraAttributesForm.vue?vue&type=script&lang=js"
export * from "./ExtraAttributesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports